module.exports = __webpack_public_path__ + "static/img/FQA_3.54a0f56.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/FQA_3.png
// module id = /zUy
// module chunks = 4